<div class="emds" id="{{Id}}" style="margin-top: -3px;">
  <mat-radio-group [name]="columnInfoDto.GroupName" [(ngModel)]="columnInfoDto.SelectedRowPk" (change)="onChange()">
    <mat-radio-button [value]="dataItem.Pk"></mat-radio-button>
  </mat-radio-group>
</div>